import AutoCorrectorLayout from '../../../components/teacherPage/auto-corrector/AutoCorrectorLayout'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/teacher/auto-corrector/')({
  component: AutoCorrectorLayout,
})
